import { Injectable, TemplateRef } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class UiPopoverService {
  popoverInviteContent!: TemplateRef<unknown>;
  popoverContactSupportContent!: TemplateRef<unknown>;
}
